import { Button, Modal } from 'react-bootstrap';
import Services from '../Services';
import './quickoModal.scss';
import { useTranslation } from 'react-i18next';

const QuickoServicesModal = ({ isVisible, closeFn }) => {
	const { t } = useTranslation();

	return (
		<Modal
			size="lg"
			className="service-modal-backdrop"
			onHide={closeFn}
			show={isVisible}
		>
			<Modal.Header closeButton>
				<Modal.Title className="text-capitalize">{t('services')}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="pb-0">
				<Services />
			</Modal.Body>
			<Modal.Footer className="border-0 pt-0">
				<Button
					variant="outline-secondary"
					className="mx-auto w-50"
					onClick={closeFn}
					type="button"
				>
					{t('confirm')}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default QuickoServicesModal;
